import React, { useState } from 'react';
import { connect, useIntl } from 'umi';
import { Col, Row } from 'tea-component';
import CardCommon from '@op/components/CardCommon';
import SteamGameStore from '../components/SteamGameStore';
import ReviewsTimeline from '../components/ReviewsTimeline';
import '@/pages/opinion/assets/scss/pages/feeds/GameStore.scss';
import SvgIcon from '@/pages/home/components/SvgIcon';
import usePcConsoleTimelineChart from '../../gamestore/hooks/usePcConsoleTimelineChart';
import '../scss/steamAllReviews.scss';
import { downloadAction } from '@op/components/DownloadCommon/download-page';
import useSteamUrl from '@op/hooks/useSteamUrl';
import { useEmptyInfo } from '../hooks';
import {
  steamPerformanceAllReviewsTips,
  type TipsMapType,
} from '@op/components/BubbleCommon';

type SteamItemType = {
  title: string;
  keys: Array<string>;
  timelineKey: 'all_reviews' | 'recent_reviews';
  timeTips: string;
  nearTotalTips?: TipsMapType;
  isRecent?: boolean;
};

const steam: SteamItemType[] = [
  {
    title: 'All Reviews',
    keys: ['all_reviews', 'all_reviews_non_recommend', 'all_reviews_recommend'],
    timelineKey: 'all_reviews',
    timeTips: "from the game's release on Steam to {time}",
    nearTotalTips: steamPerformanceAllReviewsTips,
  },
  {
    title: 'Recent Reviews',
    keys: [
      'recent_reviews',
      'recent_reviews_non_recommend',
      'recent_reviews_recommend',
    ],
    timelineKey: 'recent_reviews',
    timeTips: 'last 30 days up to {time}',
    isRecent: true,
  },
];
export default function SteamAllReviews({
  userScore = {},
  loading,
  filter,
  timeline,
  timelineLoading,
}: any) {
  const { formatMessage } = useIntl();
  const [showMore, setShowMore] = useState(true);
  const { chartMap } = usePcConsoleTimelineChart({
    platformData: timeline.steam,
    filterParams: filter,
  });

  function downloadReviewsInfo(valueKey: 'all_reviews' | 'recent_reviews') {
    const name =
      valueKey === 'all_reviews' ? 'Steam All Reviews' : 'Steam Recent Reviews';
    downloadAction({
      limit: 150000,
      downLoadParams: {
        ...filter,
        channel: ['steam'],
        valueKey,
        channels: ['steam'],
        metrics: ['recommend', 'non_recommend'],
        ret_metrics: ['recommend', 'non_recommend'],
        types: ['total', 'slice'],
      },
      downloadFunc: 'getOverviewPcConsoleTimeline',
      simpleName: name,
      sheetName: name,
    });
  }

  const { goToSteamUrl } = useSteamUrl({ gameInfo: filter });

  return (
    <CardCommon
      className={`steam-all-reviews-wrapper feeds-userscorebox   ${
        showMore ? 'show-all' : ''
      }`}
      loading={loading}
      loadingHeight={448.75}
      emptyHeight={448.75}
    >
      <div>
        <Row className="feeds-userscorebox-row">
          <>
            {steam.map((item, index) => {
              return (
                <Col
                  key={item.title}
                  className="steam-all-review-col"
                  span={index === 0 ? 15 : 9}
                >
                  <ReviewItem
                    {...item}
                    filter={filter}
                    goToSteamUrl={goToSteamUrl}
                    userScore={userScore}
                    loading={timelineLoading}
                    showMore={showMore}
                    chartMap={chartMap}
                    downloadReviewsInfo={downloadReviewsInfo}
                  ></ReviewItem>
                </Col>
              );
            })}
          </>
        </Row>
        <div
          className="steam-feeds-userscorebox-more feeds-userscorebox-more dbo-more-btn"
          onClick={() => setShowMore(!showMore)}
        >
          <span>
            {formatMessage({ id: showMore ? 'Close' : 'Show graph' })}
            <SvgIcon
              type={!showMore ? 'point-down' : 'point-top'}
              className="dbo-more-btn-icon"
            />
          </span>
        </div>
      </div>
    </CardCommon>
  );
}

const ReviewItem = connect((state: any) => {
  const { opinionCommon } = state;
  return {
    wholeGameInfo: opinionCommon.wholeGameInfo,
  };
})(({
  title,
  keys,
  timelineKey,
  timeTips,
  filter,
  goToSteamUrl,
  userScore,
  loading,
  chartMap,
  downloadReviewsInfo,
  showMore,
  wholeGameInfo,
  nearTotalTips,
  isRecent,
}: {
  filter: any;
  goToSteamUrl: any;
  userScore: any;
  loading: boolean;
  chartMap: any;
  downloadReviewsInfo: any;
  showMore: boolean;
  wholeGameInfo: any;
} & SteamItemType) => {
  const {
    chartData,
    chartEmpty,
    steamData,
    steamGameEmpty,
    allEmpty,
    emptyText,
  } = useEmptyInfo({
    chartMap,
    timelineKey,
    userScore,
    keys,
    wholeGameInfo,
    isRecent,
  });

  return (
    <>
      <SteamGameStore
        title={title}
        keys={keys}
        filter={filter}
        shareClick={goToSteamUrl}
        timeTips={timeTips}
        nearTotalTips={nearTotalTips}
        data={steamData} 
        hasDownload
        emptyHeight={allEmpty ? 0 : 104}
        empty={steamGameEmpty}
        hasEmptyDesc={!allEmpty}
        handleDownloadOnClick={() => downloadReviewsInfo(timelineKey)}
      ></SteamGameStore>
      <div className="timeline-box">
        <ReviewsTimeline
          filter={filter}
          isRecent={timelineKey === 'recent_reviews'}
          loading={loading}
          empty={chartEmpty}
          data={chartData}
          hasEmptyImg={showMore}
          hasEmptyTitle={false}
          emptyDescText={emptyText}
          emptyHeight={showMore ? 330 : 100}
        ></ReviewsTimeline>
      </div>
    </>
  );
});
